"use strict";

export enum AppointmentDistribution {
    MINUTES_90 = 90,
    MINUTES_60 = 60,
    MINUTES_30 = 30,
    MINUTES_15 = 15
}
